import Callout, { CalloutMode } from "../../ui_atoms/Callout";
import type { Meta, StoryObj } from "@storybook/react";
import VStack from "../../ui_atoms/VStack";

const SAMPLE_MD_1 = `
# Hello title
## Title 2
### Title 3
#### Title 4
This is a super information
`;

const SIMPLE_MD = `Merci de joindre certificats, attestations qui justifient du nombre d’années d’expérience et les diplômes, formations qui justifient vos qualifications.`;

const WARNING_MD = `
# ⚠️Warning 
## subtitle
This is the last call for passenger *Jojo bubu*. 

Please proceed immediately to gate 0!
`;

const ERROR_MD = `
# ‼️Fatal error
## subtitle
Your computer is about to shudown and blow out in a RAVAGING **EXPLOSION** or **smaller** little sparkles.
`;

const StoryComponent = ({ markdown, mode }: { markdown: string; mode?: CalloutMode }) => {
    return (
        <VStack h={1}>
            <Callout markdown={markdown} mode={mode} />
        </VStack>
    );
};

const meta = {
    title: "Atom/Callout",
    component: StoryComponent,
    argTypes: {},
    parameters: {
        sherlo: {
            exclude: false,
        },
    },
} satisfies Meta<typeof Callout>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        markdown: SAMPLE_MD_1,
    },
};

export const Simple: Story = {
    args: {
        markdown: SIMPLE_MD,
    },
};

export const Warning: Story = {
    args: {
        markdown: WARNING_MD,
        mode: "warning",
    },
};

export const Error: Story = {
    args: {
        markdown: ERROR_MD,
        mode: "error",
    },
};
